import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, brl, fmtDate, formatError, maskCpf } from "@/lib/api";

const Missing = () => <span className="text-xs italic text-slate-400">não informado</span>;

const matches = (c, term) => {
  if (!term) return true;
  const digits = term.replace(/\D/g, "");
  if ([c.name, c.email].some((v) => (v || "").toLowerCase().includes(term))) return true;
  return !!digits && [c.cpf || "", (c.phone || "").replace(/\D/g, "")].some((v) => v.includes(digits));
};

function CustomerRow({ c }) {
  return (
    <TableRow data-testid={`customer-row-${c.user_id}`}>
      <TableCell className="whitespace-nowrap font-semibold">
        {c.name}
        {c.role === "vip" && <span className="ml-2 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-800" data-testid={`customer-vip-badge-${c.user_id}`}>VIP</span>}
      </TableCell>
      <TableCell className="text-sm" data-testid={`customer-email-${c.user_id}`}>{c.email}</TableCell>
      <TableCell className="whitespace-nowrap text-sm" data-testid={`customer-phone-${c.user_id}`}>{c.phone || <Missing />}</TableCell>
      <TableCell className="whitespace-nowrap font-mono text-sm" data-testid={`customer-cpf-${c.user_id}`}>{c.cpf ? maskCpf(c.cpf) : <Missing />}</TableCell>
      <TableCell className="whitespace-nowrap text-xs text-slate-500">{fmtDate(c.created_at)}</TableCell>
      <TableCell className="font-mono">{c.orders_count}</TableCell>
      <TableCell className="whitespace-nowrap font-mono">{brl(c.paid_total)}</TableCell>
    </TableRow>
  );
}

export default function AdminCustomers() {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/customers").then((r) => setList(r.data)).catch((e) => toast.error(formatError(e)));
  }, []);

  const shown = (list || []).filter((c) => matches(c, q.trim().toLowerCase()));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight" data-testid="customers-title">Clientes</h1>
        <p className="text-slate-500" data-testid="customers-count">{list ? `${list.length} clientes cadastrados (clientes e Clientes VIP)` : "Carregando..."}</p>
      </div>
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, e-mail, telefone ou CPF" className="h-11 bg-white pl-9" data-testid="customers-search-input" />
      </div>
      <div className="overflow-x-auto rounded-md border border-slate-200 bg-white">
        <Table data-testid="admin-customers-table">
          <TableHeader>
            <TableRow><TableHead>Nome</TableHead><TableHead>E-mail</TableHead><TableHead>Telefone</TableHead><TableHead>CPF</TableHead><TableHead>Cadastro</TableHead><TableHead>Pedidos</TableHead><TableHead>Total pago</TableHead></TableRow>
          </TableHeader>
          <TableBody>{shown.map((c) => <CustomerRow key={c.user_id} c={c} />)}</TableBody>
        </Table>
        {list && shown.length === 0 && <p className="p-10 text-center text-sm text-slate-500" data-testid="no-customers">{q ? "Nenhum cliente encontrado para essa busca." : "Nenhum cliente cadastrado."}</p>}
      </div>
    </div>
  );
}
